import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { useTranslation } from 'hooks';
import { applyReport, usePreviewData } from './report-preview.helpers';
import {
  ReportPreviewHandle,
  ReportPreviewProps,
} from './report-preview.types';

export const ReportPreview = forwardRef<
  ReportPreviewHandle,
  ReportPreviewProps
>(({ report }, ref) => {
  const { t } = useTranslation();
  const data = usePreviewData(report);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const apply = () => {
    const doc = iframeRef.current?.contentDocument;
    if (doc) applyReport(doc, data, t);
  };

  useEffect(apply);

  useImperativeHandle(ref, () => ({
    print: () => {
      const win = iframeRef.current?.contentWindow;
      if (!win) return;
      win.focus();
      win.print();
    },
  }));

  return (
    <iframe
      ref={iframeRef}
      title={t('reportPreview')}
      src='/reportTemplate.html'
      onLoad={apply}
      style={{
        width: '100%',
        height: '100%',
        minHeight: '600px',
        border: 'none',
        display: 'block',
      }}
    />
  );
});

ReportPreview.displayName = 'ReportPreview';
